import React from 'react';
import Lottie from "lottie-react";
import b from "../../assets/browser.json"
// import { useSnap } from '../../store'
// import toast from 'react-hot-toast';


function EngWarning() {
    // const read = useSnap()


    return (

        <>
            <div className="assessment-tab-warning-content flex max-w-full flex-col items-center justify-center text-center">
                <Lottie className="w-16 self-center sm:w-20" animationData={b} loop={true} />
                <p className='m-0 text-sm font-extrabold leading-5 text-red-600 sm:text-base'>Do not change, minimize, or leave this tab.</p>
            </div>


        </>
    )



}


export default EngWarning
